import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { propsRecoveryState } from './interfaces';

const initialState: propsRecoveryState = {
  loading: false,
  success: false,
  error: false,
};

const recoverySlice = createSlice({
  name: 'recovery',
  initialState,
  reducers: {
    recoveryRequest: (state) => {
      state.loading = true;
      state.error = false;
    },
    recoverySuccess: (state) => {
      state.loading = false;
      state.success = true;
    },
    recoveryFailure: (state) => {
      state.loading = false;
      state.error = true;
    },
    recoverySetEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    recoverySetToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    clearRecovery: () => initialState,
  },
});

export const {
  recoveryRequest,
  recoverySuccess,
  recoveryFailure,
  recoverySetEmail,
  recoverySetToken,
  clearRecovery,
} = recoverySlice.actions;
export default recoverySlice.reducer;
